import React, { useState } from "react";
import "../../css/HappinessIndex.css";
import SchoolHero from "../SchoolLevels/SchoolHero";

const MEASURES = [
  {
    icon: "📋",
    text: "Questionnaires shared with students and families to gauge overall happiness",
  },
  {
    icon: "💬",
    text: "Direct feedback collected from students about their experience at school",
  },
  { icon: "👪", text: "Testimonials and insights gathered from parents" },
  {
    icon: "📅",
    text: "Attendance trends tracked as an indicator of engagement and wellbeing",
  },
  {
    icon: "🤝",
    text: "Positive referrals and sibling admissions monitored over time",
  },
  {
    icon: "📈",
    text: "Academic performance trends observed alongside wellbeing metrics",
  },
  {
    icon: "🎨",
    text: "Participation rates in extracurricular activities, since exploring passions and making friends closely link to happiness",
  },
];

const NURTURE = [
  {
    icon: "🌈",
    title: "Environment",
    desc: "Bright, welcoming spaces and expansive outdoor learning areas create a school environment that naturally cultivates happiness.",
  },
  {
    icon: "📚",
    title: "Curriculum",
    desc: "A rigorous academic curriculum combined with a holistic learning framework gives students an enriching, well-rounded experience.",
  },
  {
    icon: "🧑‍🏫",
    title: "Faculty Involvement",
    desc: "Thoughtful hiring ensures our teachers are genuinely passionate about working with children and creating a nurturing experience.",
  },
];

const FAQ_ITEMS = [
  {
    q: "What is the Happiness Index at Sahara Public School?",
    a: "It's a framework we use to measure and track student wellbeing, recognising that a child's happiness directly impacts their social, emotional, and academic growth.",
  },
  {
    q: "How is happiness actually measured?",
    a: "We combine questionnaires, student feedback, parent testimonials, attendance trends, and participation in extracurriculars to build a fuller picture of student wellbeing.",
  },
  {
    q: "How does the school nurture happiness day to day?",
    a: "Through a welcoming physical environment, a holistic curriculum, and teachers who are genuinely invested in each child's growth and wellbeing.",
  },
];

export default function HappinessIndex() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="hi-page">
      {}
      <SchoolHero
        title="Happiness Index"
        subtitle="World-Class Infrastructure"
        image="/images/hi.jpeg"
      />
      <section className="hi-hero">
        <h1>Happiness Index</h1>
        <p>
          Nurturing happiness through engaging curricula, a fulfilling learning
          environment, and teachers who love working with children — and
          measuring the difference it makes.
        </p>
      </section>

      {}
      <section className="wrap hi-about">
        <div>
          <h2>About the Happiness Index</h2>
          <p>
            At Sahara Public School, we believe whole-child wellbeing is just as
            important as academic achievement. A child's happiness at school
            shapes their social and emotional development as much as their
            results.
          </p>
          <p>
            To make sure every child feels happy and settled, we've built our
            own Happiness Index — a way of tracking wellbeing so we can keep
            improving the experience we offer.
          </p>
        </div>
        <div className="hi-about-img">
          <span className="emoji-badge">😊</span>
        </div>
      </section>

      {}
      <section className="hi-measure-section">
        <div className="wrap">
          <h2>How We Measure Happiness</h2>
          <p>
            Happiness may feel subjective, but it can still be tracked. We use a
            mix of tools and metrics to calculate our Happiness Index.
          </p>
          <div className="hi-measure-grid">
            {MEASURES.map((m) => (
              <div className="hi-measure-card" key={m.text}>
                <div className="hi-measure-icon">{m.icon}</div>
                <p className="hi-measure-text">{m.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="hi-nurture-section">
        <div className="wrap">
          <h2>How We Nurture Happiness</h2>
          <div className="hi-nurture-grid">
            {NURTURE.map((n) => (
              <div className="hi-nurture-card" key={n.title}>
                <div className="hi-nurture-icon">{n.icon}</div>
                <h3>{n.title}</h3>
                <p>{n.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="hi-faq">
        <div className="wrap">
          <h2>Frequently Asked Questions</h2>
          {FAQ_ITEMS.map((item, idx) => {
            const isOpen = openFaq === idx;
            return (
              <div className="faq-mini-item" key={item.q}>
                <button
                  type="button"
                  className="faq-mini-question"
                  onClick={() => setOpenFaq(isOpen ? -1 : idx)}
                >
                  <span>{item.q}</span>
                  <span>{isOpen ? "−" : "+"}</span>
                </button>
                {isOpen && <p className="faq-mini-answer">{item.a}</p>}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
